<template>
  <div class="market-top-comments">
    <div class="market-top-comments__header">
      <div class="market-top-comments__title">{{ obj.title }}</div>
      <div class="market-top-comments__arrows">
        <span @click="prevSlide" :class="prevArrowModifiers"></span>
        <span @click="nextSlide" :class="nextArrowModifiers"></span>
      </div>
    </div>
    <div class="row market-top-comments__content">
      <swiper
        v-if="!!obj"
        class="market-top-comments__slider"
        v-bind="swiperOptions"
        :modules="swiperModules"
        ref="swiper"
        @swiper="onSwiperReady"
        @transitionStart="onTransitionStart"
      >
        <swiper-slide
          v-for="(comment, index) in items"
          :key="index"
          class="market-top-comments__slide"
        >
          <top-comment :comment="comment"></top-comment>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script src="./market-top-comments.js"></script>
<style src="./market-top-comments.scss" lang="scss"></style>
